module.exports = __webpack_public_path__ + "static/media/zadania-z-matematyki.41134c2c.png";